import { formFieldErrorHtml, mergePreviewStyle, toRGBA } from "../parser/utils";
import { getFormLableStyleStr } from "../FormText/FormBaseStyle";

export default ({ data, id, root }) => {
  const {
    label,
    required,
    lowRatingLabel,
    highRatingLabel,
    ratingLevel = 5,
    ratingStyle,
    hideLabel,
    paddingTop,
    paddingBottom,
    paddingRight,
    paddingLeft,
    labelDefaultFont,
    labelFontSize,
    labelFontColor,
    labelHorizonAlignment,
  } = data;

  const {
    formBorderWidth,
    formBorderStyle,
    formBorderColor,
    formBorderRadius,
    formTextColor,
  } = root.data;

  const baseLabelStyleStr = getFormLableStyleStr(data, root.data) || "";

  const overrideStyleParts = [];
  overrideStyleParts.push('display: flex');
  overrideStyleParts.push('align-items: flex-start');

  const finalLabelFontColor = labelFontColor || formTextColor;
  if (finalLabelFontColor) {
    overrideStyleParts.push(`color: ${toRGBA(finalLabelFontColor)}`);
  }
  if (labelDefaultFont) {
    overrideStyleParts.push(`font-family: ${labelDefaultFont}`);
  }
  const trimmedLabelFontSize = String(labelFontSize || "").trim();
  if (trimmedLabelFontSize && trimmedLabelFontSize !== '0') {
    overrideStyleParts.push(`font-size: ${trimmedLabelFontSize}px`);
  }
  overrideStyleParts.push(`justify-content: ${labelHorizonAlignment || "start"}`);

  const labelInlineStyleString = overrideStyleParts.join('; ');
  const finalLabelStyleStr = mergePreviewStyle(baseLabelStyleStr, labelInlineStyleString);

  const ratingScript = ratingStyle === "star"
    ? `<script>
         $("#${id}").StarsRating({ size: '16px', count: ${ratingLevel}, score: 1, name: "${id}" });
       </script>`
    : "";

  return `
    <div
      class="rip-field-group"
      style="
        text-align: left;
        padding-top: ${paddingTop}px;
        padding-bottom: ${paddingBottom}px;
        padding-right: ${paddingRight}px;
        padding-left: ${paddingLeft}px;
      "
    >
      <label
        for="${id}"
        style="${finalLabelStyleStr}; display: ${hideLabel ? 'none' : 'flex'};"
      >
        ${required ? '<span style="color: #ff4d4f; margin-right: 4px;">*</span>' : ""}${label}
      </label>

      <div
        id="${id}"
        style="
          padding: 5px;
          border-width: ${formBorderWidth}px;
          border-style: ${formBorderStyle};
          border-color: ${toRGBA(formBorderColor)};
          border-radius: ${formBorderRadius}px;
        "
      >
        <div
          style="
            display: ${hideLabel ? 'none' : 'flex'};
            justify-content: space-between;
            border-bottom: ${formBorderWidth}px ${formBorderStyle} ${toRGBA(formBorderColor)};
          "
        >
          <div style="${finalLabelStyleStr}">${lowRatingLabel}</div>
          <div style="${finalLabelStyleStr}">${highRatingLabel}</div>
        </div>

        <div
          style="
            display: flex;
            justify-content: space-between;
            padding-top: 5px;
          "
        >
          ${Array(ratingLevel)
            .fill(null)
            .map((_, index) => {
              if (ratingStyle === "number") {
                return `
                  <div style="text-align: center;">
                    <div>
                      <input
                        id="${id}-${index + 1}"
                        name="${id}"
                        style="width: 16px; height: 16px; /* 可根据需要调整输入框样式 */"
                        type="radio"
                        value="${index + 1}"
                      />
                    </div>
                    <label for="${id}-${index + 1}" style="color: ${toRGBA(formTextColor)};">
                      ${index + 1}
                    </label>
                  </div>`;
              }
              return `<div style="font-size: 16px; color: orange;">★</div>`;
            })
            .join('')}
        </div>

        ${ratingScript}
      </div>

      ${formFieldErrorHtml({ id })}
    </div>
  `;
};